"use client";

import React from "react";
import { Phone, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AdditionCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2,
    once: true
  });
  return <section id="additionprojectctaband" data-nav="dark" className="relative overflow-hidden bg-secondary py-16 text-secondary-foreground sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <h2 className="font-serif text-3xl font-medium tracking-tight text-secondary-foreground sm:text-4xl lg:text-5xl">
            Start Your Brookhaven Home Addition Project
          </h2>

          <p className="mx-auto mt-4 max-w-2xl text-base text-secondary-foreground/80 sm:mt-5 sm:text-lg">
            Consult directly with our design and construction team for seamless
            craftsmanship, clear budgets, and dependable schedules.
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-5">
            <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground shadow-md hover:bg-primary/90 font-medium">
              <Link to="/ContactRequestAnEstimatePage">
                <span>Get a Free Estimate</span>
                <ArrowRight className="size-4" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-secondary-foreground/25 bg-transparent text-secondary-foreground shadow-xs hover:bg-secondary-foreground/10 hover:text-secondary-foreground">
              <a href="tel:+14708479076">
                <Phone className="size-4" />
                <span>Call (470) 847-9076</span>
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}